<div [formGroup]="fpGroup">
  <app-modal-container
    [title]="header"
    [buttons]="modalButtons"
    [applyActivated]="checkApplyActivated()"
    [lowerLeftActivated]="!fpGroup.value.blocked"
    [applyHint]="hintOnBlockedPeriod"
    [lowerLeftHint]="hintOnBlockedPeriod"
    [spinnerProps]="spinnerProps"
    (dismissButtonClicked)="close(false)"
    (closeButtonClicked)="close(false)"
    (applyButtonClicked)="confirmUpdateFundPerformance()"
    (lowerLeftButtonClicked)="emitDeleteFundPerf()">

    <div class="flex flex-col gap-0.9375">
      <div class="flex flex-col gap-0.9375">
        <div class="flex gap-0.9375">
          <app-input
            data-qa="total-commitment"
            class="w-[43.9rem]"
            formControlName="totalCommitment"
            [title]="'Commitment'"
            [separator]="'separator.0'"
            [thousandSeparator]="','"
            [additionalClass]="errorClass.totalCommitment">
          </app-input>
          <div class="flex items-end gap-0.9375 grow">
            <app-checkbox
              data-qa="fund-performance-block-period"
              class="w-[14rem] checkbox-no-padding "
              formControlName="blocked"
              [bottomDescription]="'Block from changes'"
              [suffixImgAndStyling]="'lock-closed-fill.svg; black-9; icon-size-1p25'">
              Locked
            </app-checkbox>
            <app-checkbox
              data-qa="fund-performance-predict-period"
              class="w-[14rem] checkbox-no-padding"
              formControlName="isBasedOnPrognosis"
              [bottomDescription]="'Estimated data'"
              [suffixImgAndStyling]="'prediction.svg; black-9; icon-size-1p25'">
              Predicted
            </app-checkbox>
            <app-checkbox
              data-qa="fund-performance-hide-period"
              class="w-[14rem] checkbox-no-padding"
              [bottomDescription]="'Hide from viewer'"
              [checked]="!fpGroup.value.isVisible"
              (checkBoxClicked)="changeIsVisibleValue()"
              [suffixImgAndStyling]="'crossed-eye.svg; black-9; icon-size-1p25'">
              Hidden
            </app-checkbox>
          </div>
        </div>
        <div class="grey-line for-padding-1p25"></div>
      </div>

      <div class="vertical-container-simple column-gap-1">
        <div class="font-2 bold600">Partners capital</div>
        <div class="flex gap-0.9375 input-width">
          <app-input
            data-qa="contribution"
            formControlName="contribution"
            [title]="'Contribution'"
            [separator]="'separator.0'"
            [thousandSeparator]="','"
            [additionalClass]="errorClass.contribution"
            [suffixText]="calculateSuffixText('contribution')">
          </app-input>
          <app-input
            data-qa="portfolio-gain"
            formControlName="portfolioGain"
            [title]="'Portfolio Gain/Loss'"
            [separator]="'separator.0'"
            [thousandSeparator]="','"
            [allowNegativeNumbers]="true">
          </app-input>
          <app-input
            data-qa="total-expenses"
            formControlName="totalExpenses"
            [title]="'Operating expenses'"
            [separator]="'separator.0'"
            [thousandSeparator]="','"
            [pointerOnToolTip]="true"
            [allowNegativeNumbers]="!fpGroup.value.isTotalExpensesPositive"
            [additionalClass]="errorClass.totalExpenses"
            [suffixText]="calculateSuffixText('totalExpenses')"
            [suffixFirstIcon]="fpGroup.value.totalExpIcon"
            [firstSuffixImageTooltip]="fpGroup.value.totalExpToolTip"
            (suffixFirstIconEmitter)="toggleIsTotalExpensesPositive()">
          </app-input>
          <app-input
            data-qa="lp-distribution"
            formControlName="distribution"
            [title]="'Distribution'"
            [separator]="'separator.0'"
            [thousandSeparator]="','"
            [allowNegativeNumbers]="true"
            [additionalClass]="errorClass.distribution">
          </app-input>
          <app-input
            data-qa="carry-distribution"
            formControlName="carryDistribution"
            [title]="'Carry distribution'"
            [separator]="'separator.0'"
            [thousandSeparator]="','"
            [allowNegativeNumbers]="true"
            [additionalClass]="errorClass.carryDistribution">
          </app-input>
          <app-input
            formControlName="partnersCapital"
            data-qa="partners-capital"
            [title]="'Partners capital (NAV)'"
            [separator]="'separator.2'"
            [thousandSeparator]="','"
            [additionalClass]="errorClass.partnersCapital"
            [allowNegativeNumbers]="true"
            [bottomText]="errorClass.distribution ? 'Can\'t be negative' : ''">
          </app-input>
        </div>
      </div>

      <div *ngIf="!fpGroup.value.isTotalExpensesPositive"
        class="grey-modal-container vertical-container-simple column-gap-0p5">
        <div class="start-row-container row-gap-0p5">
          <label class="font-2 bold600">Expenses drilldown</label>
          <app-button
            *ngIf="showExpensesButton"
            data-qa="show-exp-prediction"
            [type]="'accent'"
            [iconName]="'calculator.svg'"
            [size]="'xsmall'"
            (click)="showExpensesPrediction()">
            Prediction
          </app-button>
        </div>
        <div class="flex">
          <app-input
            data-qa="total-expenses-positive"
            class="grow"
            formControlName="totalExpenses"
            [title]="'Operating expenses'"
            [separator]="'separator.0'"
            [thousandSeparator]="','"
            [additionalClass]="'disabled'"
            [allowNegativeNumbers]="true">
          </app-input>
          <div class="xAxis-whitespace-1 math-sign">=</div>
          <app-input
            data-qa="mgm-fees"
            class="grow"
            formControlName="mgmFees"
            [title]="'Management fees'"
            [separator]="'separator.0'"
            [thousandSeparator]="','"
            [allowNegativeNumbers]="true">
          </app-input>
          <div class="xAxis-whitespace-1 math-sign">+</div>
          <app-input
            data-qa="aggregated-org-expenses"
            class="grow"
            formControlName="aggregatedOrgExpenses"
            [title]="'Organizational expenses'"
            [separator]="'separator.0'"
            [thousandSeparator]="','"
            [allowNegativeNumbers]="true">
          </app-input>
          <div class="xAxis-whitespace-1 math-sign">+</div>
          <app-input
            data-qa="other-expenses"
            class="grow"
            formControlName="otherExpenses"
            [title]="'Other expenses'"
            [separator]="'separator.0'"
            [thousandSeparator]="','"
            [additionalClass]="'disabled'"
            [allowNegativeNumbers]="true">
          </app-input>
        </div>
      </div>
      <div class="vertical-container-simple column-gap-0p5">
        <div class="flex gap-0.15625">
          <label class="font-2 bold600">Net performance</label>
          <label class="font-2 bold600 main-8">before carry</label>
        </div>
        <div class="flex gap-0.9375">
          <app-input
            data-qa="navAndDistributionBeforeCarry"
            class="grow"
            formControlName="navAndDistributionBeforeCarry"
            [title]="'NAV & Distribution'"
            [separator]="'separator.0'"
            [thousandSeparator]="','"
            [allowNegativeNumbers]="true">
          </app-input>
          <app-input
            data-qa="netGainBeforeCarry"
            class="grow"
            formControlName="netGainBeforeCarry"
            [title]="'Net Gain/Loss'"
            [separator]="'separator.0'"
            [thousandSeparator]="','"
            [allowNegativeNumbers]="true">
          </app-input>
          <app-input
            data-qa="tvpiBeforeCarry"
            formControlName="tvpiBeforeCarry"
            class="grow"
            [title]="'TVPI'"
            [separator]="'separator.2'"
            [thousandSeparator]="','"
            [suffixFirstIcon]="fpGroup.value.tvpiBeforeCarryIcon"
            [prefix]="fpGroup.value.totalExpenses === null ? '' : 'x'">
          </app-input>
          <app-input
            data-qa="calc-net-irr"
            formControlName="irrCalculated"
            [title]="'Calculated Net IRR'"
            [separator]="'separator.2'"
            [thousandSeparator]="','"
            [allowNegativeNumbers]="true"
            [suffix]="'%'"
            [buttonProps]="selected.fp.isIrrCanBeCalculated ? buttonProps : null"
            (buttonClick)="exportCalculationIrr()">
          </app-input>
          <app-input
            data-qa="netIrr"
            class="grow"
            formControlName="netIrr"
            [title]="'Manual IRR'"
            [separator]="'separator.4'"
            [thousandSeparator]="','"
            [suffix]="'%'"
            [allowNegativeNumbers]="true">
          </app-input>
        </div>
      </div>
      <div  class="grey-modal-container vertical-container-simple column-gap-0p5">
        <label class="font-2 bold600">Carried interest</label>
        <div class="flex gap-0.9375">
          <app-carry-combined-inputs [formGroup]="fpGroup"/>
          <app-input
            data-qa="carry-distribution-duplicated"
            class="grow"
            formControlName="carryDistribution"
            [title]="'Carry distribution'"
            [separator]="'separator.0'"
            [thousandSeparator]="','"
            [allowNegativeNumbers]="true"
            [additionalClass]="errorClass.carryDistribution">
          </app-input>
          <app-input
            data-qa="unrealized-carry"
            class="grow"
            formControlName="unrealizedCarry"
            [title]="'Unrealized carry'"
            [separator]="'separator.0'"
            [thousandSeparator]="','"
            [allowNegativeNumbers]="true"
            [additionalClass]="errorClass.unrealizedCarry">
          </app-input>
          <app-input
            data-qa="nav-after-carry"
            class="grow"
            formControlName="navAfterCarry"
            [title]="'Partners capital (After carry)'"
            [separator]="'separator.0'"
            [thousandSeparator]="','">
          </app-input>
        </div>
      </div>
      <ng-container *ngIf="fpGroup.value.carryInterest">
        <div class="vertical-container-simple column-gap-0p5">
          <div class="flex gap-0.15625">
            <label class="font-2 bold600">Net performance</label>
            <label class="font-2 bold600 main-8">after carry</label>
          </div>
          <div class="flex gap-0.9375">
            <app-input
              data-qa="navAndDistributionAfterCarry"
              class="grow"
              formControlName="navAndDistributionAfterCarry"
              [title]="'NAV & Distribution'"
              [separator]="'separator.0'"
              [thousandSeparator]="','"
              [allowNegativeNumbers]="true">
            </app-input>
            <app-input
              data-qa="netGainAfterCarry"
              class="grow"
              formControlName="netGainAfterCarry"
              [title]="'Net Gain/Loss'"
              [separator]="'separator.0'"
              [thousandSeparator]="','"
              [allowNegativeNumbers]="true">
            </app-input>
            <app-input
              formControlName="tvpiAfterCarry"
              class="grow"
              data-qa="tvpi-after-carry"
              [title]="'TVPI'"
              [separator]="'separator.2'"
              [thousandSeparator]="','"
              [suffixFirstIcon]="fpGroup.value.tvpiAfterCarryIcon"
              [prefix]="'x'">
            </app-input>
            <app-input
              formControlName="irrCalculatedAfterCarry"
              data-qa="irr-calc-after-carry"
              [title]="'Calculated Net IRR'"
              [separator]="'separator.2'"
              [thousandSeparator]="','"
              [allowNegativeNumbers]="true"
              [suffix]="'%'"
              [buttonProps]="selected.fp.isIrrCanBeCalculated ? buttonProps : null"
              (buttonClick)="exportCalculationIrr()">
            </app-input>
            <app-input
              formControlName="netIrrAfterCarry"
              class="grow"
              data-qa="netIrrAfterCarry"
              [title]="'Manual IRR'"
              [separator]="'separator.4'"
              [thousandSeparator]="','"
              [allowNegativeNumbers]="true"
              [suffix]="'%'">
            </app-input>
          </div>
        </div>
      </ng-container>
      <app-input
        class="textarea-height-8 "
        formControlName="comment"
        data-qa="comment"
        [title]="'Comment'"
        [maxLength]="MAX_COMMENT_LEN"
        [textArea]="true">
      </app-input>
    </div>

    <app-modal-expenses-prediction
      *ngIf="showExpensesPredictionModal"
      [fundPerformanceList]="updatedFpList"
      [updatedFundPerformance]="fpGroup.value"
      (closeModalEmitter)="showExpensesPredictionModal = false"
      (expensesEmitter)="setExpenses($event)">
    </app-modal-expenses-prediction>
  </app-modal-container>
</div>
